/**
 * Focus a closing popover hands back to its trigger is not the user arriving at that trigger. Radix
 * opens a tooltip on any focus that no pointer press caused, so an Escape-closed popover would light up
 * its trigger's tooltip (and nobody's pointer is there to close it again).
 *
 * `KuikaPopover` marks the hand-back from its `onCloseAutoFocus`; Radix focuses the trigger
 * synchronously right after that handler returns, so the mark only has to outlive the current task and
 * is cleared on a microtask.
 */
let isRestoringFocus: boolean = false;

export function markPopoverFocusRestore(): void {
  isRestoringFocus = true;
  queueMicrotask((): void => {
    isRestoringFocus = false;
  });
}

export function isPopoverFocusRestore(): boolean {
  return isRestoringFocus;
}
